import { Helmet } from 'react-helmet-async';

export interface HeadProps {
  title?: string;
  description?: string;
}

export const Head = ({ title = '', description = '' }: HeadProps = {}) => {
  return (
    <Helmet title={title ? `BarTopTV | ${title}` : undefined} defaultTitle="BarTopTV">
      <meta name="description" content={description} />
    </Helmet>
  );
};
